import React, { useState, useEffect } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import TextField from "@material-ui/core/TextField/TextField";
import Typography from "@material-ui/core/Typography/Typography";
import { Translate } from "../../../config/Translate";

const ChooseDate = ({ input, handleDate, size, variant, margin, label, error, required }) => {
    const [date, setDate] = useState(null);

    // Convert input string (1404/12/12) to object
    useEffect(() => {
        if (input) {
            const parts = input.split("/");
            if (parts.length === 3) {
                setDate({
                    year: parseInt(parts[0]),
                    month: parseInt(parts[1]),
                    day: parseInt(parts[2]),
                });
            }
        } else {
            setDate(null);
        }
    }, [input]);

    const onDateChange = (newDate) => {
        setDate(newDate);
        if (newDate) {
            const shamsiDate = `${newDate.year}/${String(newDate.month).padStart(2, "0")}/${String(newDate.day).padStart(2, "0")}`;
            handleDate(shamsiDate);
        } else {
            handleDate("");
        }
    };

    const renderCustomInput = ({ ref }) => (
        <TextField
            readOnly
            fullWidth
            required={required}
            size={size || "medium"}
            variant={variant || "standard"}
            margin={margin}
            ref={ref}
            label={label || Translate.chooseDate}
            value={
                date
                    ? `${date.year}/${String(date.month).padStart(2, "0")}/${String(date.day).padStart(2, "0")}`
                    : ""
            }
        />
    );

    return (
        <>
            <DatePicker
                value={date}
                onChange={onDateChange}
                shouldHighlightWeekends
                renderInput={renderCustomInput}
                locale="fa"
            />
            {error ? (
                <Typography className="errorText" color="error" variant="body2">
                    {error}
                </Typography>
            ) : null}
        </>
    );
};

export default ChooseDate;
